import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SmartContractViewService } from "../smart-contract-view.service";
import { SmartContractOperationService } from "../../smart-contract-operation/smart-contract-operation.service";

@Component({
  selector: 'app-smart-contract-view-history',
  templateUrl: './smart-contract-view-history.component.html'
})
export class SmartContractViewHistoryComponent implements OnInit {

  chaincodeId!: string;
  key!: string;

  channel!: string;
  chaincode!: string;

  history: any[] = [];

  headers = [
    { name: 'Block', property: 'block', showInDropdown: true },
    { name: 'TxId', property: 'txId', showInDropdown: true },
    { name: 'Key', property: 'key', showInDropdown: true },
    { name: 'Content', property: 'content', showInDropdown: true },
    { name: 'Event', property: 'event', showInDropdown: true },

  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: SmartContractViewService,
    private contractService: SmartContractOperationService
  ) { }

  ngOnInit(): void {
    this.chaincodeId = this.route.snapshot.paramMap.get('id')!;
    this.key = this.route.snapshot.paramMap.get('key')!;

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras.state as any;

    if (state) {
      this.channel = state.channel;
      this.chaincode = state.chaincode;
      this.loadHistory();
    } else {
      this.loadChaincodeDetails();
    }
  }

  loadChaincodeDetails() {
    this.contractService.getContractById(this.chaincodeId)
      .subscribe((data: any) => {

        if (!data) {
          alert("Chaincode not found");
          return;
        }

        this.channel = data.channelName;
        this.chaincode = data.chaincodeName;

        this.loadHistory();
      });
  }

  loadHistory(): void {
    this.service.getHistory(this.channel, this.chaincode, this.key)
      .subscribe((res: any[]) => {

        this.history = res.map(h => ({
          block: h.timestamp,
          txId: h.txId,
          key: h.value?.ledgerKey || this.key,
          content: h.value?.content,
          event: h.isDelete ? 'DELETE' : 'UPDATE'
        }));
      });
  }

  back(): void {
    this.router.navigate(
      ['/secure-blockchain/auth-tools/view', this.chaincodeId]
    );
  }
}